export default "__VITE_ASSET__C45rGO03__"